exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auth-status[data-v-8c820c58]{background:#e9ebef;border-radius:.16rem;padding:0 .1rem;height:.32rem;line-height:.32rem;font-size:.18rem;color:#929dad}.auth-status img[data-v-8c820c58]{height:.22rem;margin-right:.08rem}.auth-status.status1[data-v-8c820c58]{background:#fde3e9;color:#f0426c}.auth-status.status2[data-v-8c820c58]{background:#ecf9de;color:#7ed321}.auth-status.status3[data-v-8c820c58]{background:#e9ebef;color:#929dad}", ""]);

// exports
